import * as fromRouter from '@ngrx/router-store';
import { IRouterUrlState } from './router';
import { ActionReducerMap } from '@ngrx/store';

export interface NHARootState {
	router: fromRouter.RouterReducerState<IRouterUrlState>;
}

export const nhaRootReducers: ActionReducerMap<NHARootState> = {
	router: fromRouter.routerReducer
};
